<template>
    <div class="swiperBox swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="swiper-slide"
          >
            <div class="img-box2">
              <img v-show="item.img" :src="item.img" alt="" />
              <video 
                v-show="!item.img" 
                :ref="'video_' + index"
                :class="'video_' + index"
                :id="'video_' + index"
                :src="item.video" 
                :poster="item.poster"
                style="width: 100%;height: 100%;object-fit: fill" 
                controls="controls"
              ></video>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
</template>
<script>
import createAudio from './dialog/audio.js'

export default {
  props: ["cityCode","audioPlayStatus"],
  data() {
    return {
      imgList: [],
      imgCache:{
        "":[]
      },
      swiperList: {
        swiper2: null,
      },
      play: false
    };
  },
  mounted() {
    switch (this.cityCode){
      case 'beijing':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/bj-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/bj-2.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/bj-3.png",
          }
        ];
        break;
      case 'chengdu':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/cd-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/cd-2.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/cd-3.png",
          }
        ];
        break;
      case 'kunming':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/km-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/km-2.png",
          }
        ];
        break;
      case 'chongqing':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/cq-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/cq-2.png",
          }
        ];
        break;
      case 'shanghai':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/sh-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/sh-2.png",
          }
        ];
        break;
      case 'guangzhou':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/gz-1.png",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/gz-2.png",
          }
        ];
        break;
      case 'haerbin':
        this.imgList = [
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/city/heb-1.png",
          }
        ];
        break;
      case 'SEOUL':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/shouer.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/se/se-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/se/se-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/se/se-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/se/se-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/se/se-4.jpg",
          },
        ];
        break;
      case 'ANTON':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/andong.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/ad/ad-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/ad/ad-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/ad/ad-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/ad/ad-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/ad/ad-4.jpg",
          },
        ];
        break;
      case 'KANGNUNG':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/jiangling.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/jl/jl-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jl/jl-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jl/jl-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jl/jl-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jl/jl-4.jpg",
          },
        ];
        break;
      case 'JNMC':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/quanzhou.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/qz/qz-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/qz/qz-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/qz/qz-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/qz/qz-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/qz/qz-4.jpg",
          },
        ];
        break;
      case 'BUSAN':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/fushan.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/fs/fs-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/fs/fs-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/fs/fs-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/fs/fs-4.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/fs/fs-1.jpg",
          },
        ];
        break;
      case 'MUQING':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/mupu.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/mp/mp-1.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/mp/mp-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/mp/mp-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/mp/mp-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/mp/mp-4.jpg",
          },
        ];
        break;
      case 'JEJU':
        this.imgList = [
          {
            video: "https://source.qunarzz.com/site/images/wns/jizhou.mp4",
            poster: "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/video_poster/jz/jz-2.jpg"
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jz/jz-1.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jz/jz-2.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jz/jz-3.jpg",
          },
          {
            img:
              "https://s.qunarzz.com/srmweb/qunaradv/KoreaLightUp/koreaCity/city/jz/jz-4.jpg",
          },
        ];
        break;
      default:
      this.imgList = []
    }

    this.$nextTick(() => {
      this.swiperList.swiper2 = new Swiper(".swiperBox .swiper-container", {
        loop: false, // 循环模式选项
        pagination: {
          el: ".swiper-pagination",
        },
        direction: 'vertical',
        on:{
          slideChange: function(){
            console.log('改变了，activeIndex为'+this.activeIndex);
            if(this.activeIndex !== 0){
              document.getElementById('video_0').pause()
            }
          },
        },
      });

      var video_0 = document.getElementById('video_0');
      if(this.audioPlayStatus){
          video_0.addEventListener("pause", function(){
              document.getElementById('love_audio').play()
          });
          video_0.addEventListener("playing", function(){
              document.getElementById('love_audio').pause()
          });
      }
    });
  },
  methods: {
    goNext(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slideNext();
    },
    goPrev(swiperName) {
      let swiper = this.swiperList[swiperName];
      swiper.slidePrev();
    },
  },
};
</script>
<style lang=less scoped='true'>
/deep/ .swiper {
  position: relative;
  &-container {
    width: 280px;
    height: 175px!important;
    padding-right: 25px;
    margin-left: auto;
    margin-right: auto;
    .swiper-slide {
      height: 175px!important;
      box-sizing: border-box;
    }
    /deep/ .swiper-pagination {
      bottom: 0;
    }
    box-sizing: border-box;
    .light {
      float: left;
      &-box {
        .btn {
          padding: 2px 12px;
          border: 1px solid #feb926;
          color: #feb926;
          float: left;
          font-size: 11px;
          border-radius: 5px;
          margin-top: 8px;
          line-height: 1.414;
          margin-left: 14px;
        }
      }
      margin-top: 5px;
      img {
        width: 24px;
      }
    }
  }
  &-next,
  &-prev {
    background: url(https://picbed.qunarzz.com/80d357495b4ae2af14e7abc355f0597a.png)
      no-repeat;
    background-size: 100% auto;
    background-position: center center;
    position: absolute;
    top: 50%;
    z-index: 20;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    width: 16px;
    height: 38px;
  }
  &-next {
    right: 12px;
  }
  &-prev {
    left: 12px;
    background-image: url(https://picbed.qunarzz.com/2bb4217666b9f683ba8aa0de070da123.png);
  }
}
.img-box2 {
  position: relative;
  height: 175px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    /* position: absolute;
    left: 0;
    bottom: 0; */
  }
}
.bottom {
  margin-top: 20px;
  position: relative;
}
.jumpToContent {
  width: 100%;
  height: 91px;
  position: absolute;
  top: 70px;
}
.bottom2{
  width: 100%;
  height: 24px;
  position: absolute;
  top: 179px;
  display: block;
}
</style>